/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Topaddons3Inputs */

const id_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add-on Teratas`)
};

const ms_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add-on Teratas`)
};

const da_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top add-ons`)
};

const de_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Add-ons`)
};

const en_us2_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Add-ons`)
};

const es_es2_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementos destacados`)
};

const es_mx2_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejores complementos`)
};

const fil_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Nangungunang Add-on`)
};

const fr_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleurs add-ons`)
};

const it_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliori aggiunte`)
};

const hu_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legjobb kiegészítők`)
};

const nl_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top add-ons`)
};

const no_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp tillegg`)
};

const pl_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsze dodatki`)
};

const pt_br2_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais complementos`)
};

const pt_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores complementos`)
};

const ro_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Add-on-uri`)
};

const fi_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parhaat lisäosat`)
};

const sv_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp tillägg`)
};

const vi_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiện ích bổ sung hàng đầu`)
};

const tr_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En İyi Eklentiler`)
};

const cs_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší doplňky`)
};

const bg_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Топ добавки`)
};

const ru_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие дополнения`)
};

const uk_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найкращі доповнення`)
};

const ar_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفضل الإضافات`)
};

const hi_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप ऐड-ऑन`)
};

const th_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่วนเสริมยอดนิยม`)
};

const ja_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップアドオン`)
};

const zh_cn2_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门附加内容`)
};

const zh_hant1_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熱門附加內容`)
};

const ko_components_performancetable_collections_topaddons3 = /** @type {(inputs: Components_Performancetable_Collections_Topaddons3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`애드온 상위`)
};

/**
* | output |
* | --- |
* | "Top Add-ons" |
*
* @param {Components_Performancetable_Collections_Topaddons3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_topaddons3 = /** @type {((inputs?: Components_Performancetable_Collections_Topaddons3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Topaddons3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_topaddons3(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_topaddons3(inputs)
	if (locale === "da") return da_components_performancetable_collections_topaddons3(inputs)
	if (locale === "de") return de_components_performancetable_collections_topaddons3(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_topaddons3(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_topaddons3(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_topaddons3(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_topaddons3(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_topaddons3(inputs)
	if (locale === "it") return it_components_performancetable_collections_topaddons3(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_topaddons3(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_topaddons3(inputs)
	if (locale === "no") return no_components_performancetable_collections_topaddons3(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_topaddons3(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_topaddons3(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_topaddons3(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_topaddons3(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_topaddons3(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_topaddons3(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_topaddons3(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_topaddons3(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_topaddons3(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_topaddons3(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_topaddons3(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_topaddons3(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_topaddons3(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_topaddons3(inputs)
	if (locale === "th") return th_components_performancetable_collections_topaddons3(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_topaddons3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_topaddons3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_topaddons3(inputs)
	return ko_components_performancetable_collections_topaddons3(inputs)
});
export { components_performancetable_collections_topaddons3 as "components.performanceTable.collections.topAddOns" }